<mat-sidenav-container
  data-test-id="mat-sidenav-container"
  class="sidenav-container"
>
  <mat-sidenav
    #drawer
    class="sidenav"
    data-test-id="mat-sidenav"
    fixedInViewport="true"
    role="navigation"
    mode="side"
    opened="true"
  >
    <div class="pc-portal-logo" data-test-id="pc-portal-logo-container">
      <img data-test-id="logo" src="../../../../assets/images/pc-portal.svg" />
    </div>

    <mat-nav-list class="nav-list">
      <div>
        <div
          *ngFor="let item of menuItems"
          class="menu-item"
          [ngClass]="selectedMenuItem.id === item.id ? 'active' : 'inactive'"
          (click)="onMenuItemChange(item)"
          [attr.data-test-id]="item.id"
          mat-list-item
        >
          <div class="menu-item-content">
            <app-svg-icon
              class="icon"
              data-test-id="icon"
              [url]="item.icon"
              [isActive]="selectedMenuItem.id === item.id ? true : false"
            ></app-svg-icon>
            <span class="icon-title">{{ item.name.en }}</span>
          </div>
          <div>
            <svg
              *ngIf="item.status === 'done'"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM1.44 12C1.44 17.8321 6.16787 22.56 12 22.56C17.8321 22.56 22.56 17.8321 22.56 12C22.56 6.16787 17.8321 1.44 12 1.44C6.16787 1.44 1.44 6.16787 1.44 12Z"
                class="outer"
                fill="#9E7BFF"
              />
              <circle class="circle" cx="12" cy="12" r="9" fill="#9E7BFF" />
              <path
                class="tick"
                d="M11.536 16.071L8 12.535L9.414 11.121L11.536 13.243L15.778 9L17.192 10.414L11.536 16.071Z"
                fill="white"
              />
            </svg>
            <svg
              *ngIf="item.status === 'open'"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                class="outer"
                d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM1.44 12C1.44 17.8321 6.16787 22.56 12 22.56C17.8321 22.56 22.56 17.8321 22.56 12C22.56 6.16787 17.8321 1.44 12 1.44C6.16787 1.44 1.44 6.16787 1.44 12Z"
                fill="#9E7BFF"
              />
            </svg>
            <svg
              *ngIf="item.status === 'inProgress'"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM1.44 12C1.44 17.8321 6.16787 22.56 12 22.56C17.8321 22.56 22.56 17.8321 22.56 12C22.56 6.16787 17.8321 1.44 12 1.44C6.16787 1.44 1.44 6.16787 1.44 12Z"
                fill="#9E7BFF"
                class="outer"
              />
              <path
                d="M21 12C21 13.78 20.4722 15.5201 19.4832 17.0001C18.4943 18.4802 17.0887 19.6337 15.4442 20.3149C13.7996 20.9961 11.99 21.1743 10.2442 20.8271C8.49836 20.4798 6.89471 19.6226 5.63604 18.364C4.37737 17.1053 3.5202 15.5016 3.17293 13.7558C2.82567 12.01 3.0039 10.2004 3.68508 8.55585C4.36627 6.91131 5.51983 5.50571 6.99987 4.51677C8.47991 3.52784 10.22 3 12 3V12H21Z"
                fill="#9E7BFF"
                class="circle"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="menu-item default-menu" data-test-id="menu-item default-menu">
        <div class="logout" data-test-id="logout">
          <svg
            width="22"
            height="20"
            viewBox="0 0 22 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 2.81829e-06 10 2.81829e-06C11.5527 -0.00116364 13.0842 0.359775 14.4729 1.05414C15.8617 1.74851 17.0693 2.75718 18 4H15.29C14.1352 2.98176 12.7112 2.31836 11.1887 2.0894C9.66625 1.86044 8.11007 2.07566 6.70689 2.70922C5.30371 3.34277 4.11315 4.36776 3.27807 5.66119C2.44299 6.95462 1.99887 8.46153 1.999 10.0011C1.99913 11.5407 2.4435 13.0475 3.27879 14.3408C4.11409 15.6341 5.30482 16.6589 6.7081 17.2922C8.11139 17.9255 9.66761 18.1405 11.19 17.9113C12.7125 17.6821 14.1364 17.0184 15.291 16H18.001C17.0702 17.243 15.8624 18.2517 14.4735 18.9461C13.0846 19.6405 11.5528 20.0013 10 20ZM17 14V11H9V9H17V6L22 10L17 14Z"
              fill="#9BA6B0"
            />
          </svg>
          <span class="icon-title">Logout</span>
        </div>
      </div>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content data-test-id="mat-sidenav-content">
    <div class="nav-content" data-test-id="nav-content">
      <div class="header" data-test-id="header">
        <div class="header-left" data-test-id="header-left">
          <div class="select-container" data-test-id="pc-select">
            <app-select
              [options]="companies"
              [selectedItem]="selectedCompany"
              (handleSelection)="onCompanyChange($event)"
            ></app-select>
          </div>
          <div class="breadcrumbs" data-test-id="breadcrumbs">
            <span>
              <app-breadcrumbs [deliminator]="'/'"></app-breadcrumbs>
            </span>
          </div>
        </div>
        <div class="header-right" data-test-id="header-right">
          <div class="profile-icon">CU</div>
        </div>
      </div>

      <div class="content-container" data-test-id="content-container">
        <router-outlet></router-outlet>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
